export const environment = {
    production: false,
    frontendBaseUr: "test.sgmaobf.com",
    baseUrl: 'https://test.sgmaobf.com/api',
    baseUrlDonwload: 'https://test.sgmaobf.com/api/upload',
    gaTrackingId: 'G-K9PYBK6P0G',
};
